import MyDashboard from '../../modules/my-dashboard/MyDashboard'
import './dashboard.css';
import React from "react";

interface Props {
  readOnly?: boolean
}

const MyDashboardPage: React.FC<Props> = ({readOnly = false}) => {
  // The dashboard header (Supplier Insights title + subtitle + Tutorial Video /
  // Add Daily Deals actions) now lives inside MyDashboard so it shares the
  // redesign's `.hsb-dash` styling scope.
  return (
    <>
      <MyDashboard />
      {/* TODO: Add read-only mode support to MyDashboard component */}
    </>
  )
}

export default MyDashboardPage